import { useTheme } from 'styled-components';

import HeroThumbnail from '../../assets/images/hero-thumbnail.png';
import { Button, Flex, Typography } from '../../designComponents';
import YoutubeVideoEmbed from '../../designComponents/YoutubeVideoEmbed';
import { HeroSectionStyled } from './landing-styles';

const HeroSection = () => {
  const theme = useTheme();

  return (
    <HeroSectionStyled>
      <Typography strong className="hero-title">
        Fire Escape Plans.
        <span style={{ color: theme.colors.primary }}>
          &nbsp;Legally Compliant.
        </span>
        <span style={{ color: theme.colors.blueLight }}>
          &nbsp;Ready to Print.
        </span>
      </Typography>

      <Typography size={16} className="hero-desc">
        If you run a hotel, workplace, rental property, or construction site,
        you are legally required to display fire escape plans.
        <br />
        Upload your drawings — we turn them into professional, regulation-ready
        PDF signs.
      </Typography>

      <Flex justifyContent="center" gap="12px" margin="0px 0px 40px">
        <Button style={{ borderRadius: '28px', padding: '6px 20px' }}>
          Upload Your Plans
        </Button>
        <Button style={{ borderRadius: '28px', padding: '6px 20px' }}>
          See how it works
        </Button>
      </Flex>

      {/* Optional trust signals row (recommended) */}
      <Flex justifyContent="center" gap="24px" margin="0px 0px 30px">
        <Typography size={14}>Used by hotels & property managers</Typography>
        <Typography size={14}>Fast turnaround</Typography>
        <Typography size={14}>Print-ready PDFs</Typography>
      </Flex>

      <YoutubeVideoEmbed
        thumbnailImgURL={HeroThumbnail}
        videoPath="/bannerVideo.mp4"
      />
    </HeroSectionStyled>
  );
};

export default HeroSection;
